import { ACTIONS, QUOTE_STEPS, EVENTS } from "../AppConstants";
import { ICarrierCustomization } from "../state/interfaces";
import { IVehicle, IDriver, ICurrentInsurance, IContactInfo, IPaymentChoice, IRealTimeAutoResult, ICoverageConfig, IRate, IAgenciesContactInfo, IQuoteApiClient, IViolationList } from "../classes/Domain";
import { validationUtils, appValidator } from "../validation/Validation";
import { allFieldsValidation as startQuoteValidation } from "../validation/quickQuote/StartQuoteValidation";
import { allFieldsValidation as startPostQuoteValidation } from "../areas/post/validation/quickQuote/StartQuoteValidation";
import { allFieldsValidation as vehicleDetailsValidation } from "../validation/quickQuote/VehicleDetailsValidation";
import { allFieldsValidation as howYouDriveValidation } from "../validation/quickQuote/HowYouDriveValidation";
import { allFieldsValidation as aboutYouValidation } from "../validation/quickQuote/AboutYouValidation";
import { allFieldsValidation as educationEmploymentValidation } from "../validation/quickQuote/EducationEmploymentValidation";
import { allFieldsValidation as yourHomeValidation } from "../validation/quickQuote/YourHomeValidation";
import { allFieldsValidation as yourLicenseValidation } from "../validation/quickQuote/YourLicenseValidation";
import { allFieldsValidation as drivingHistoryValidation } from "../validation/quickQuote/DrivingHistoryValidation";
import { allFieldsValidation as currentInsuranceValidation } from "../validation/quickQuote/CurrentInsuranceValidation";
import { allFieldsValidation as insuranceHistoryValidation } from "../validation/quickQuote/InsuranceHistoryValidation";
import { allFieldsValidation as yourNewPolicyValidation } from "../validation/quickQuote/YourNewPolicyValidation";
import { allFieldsValidation as contactInfoValidation } from "../validation/quickQuote/ContactInfoValidation";
import USPSClient from "../classes/USPSClient";


export default class QuoteActions {
    private _quoteApiClient: IQuoteApiClient;

    constructor(quoteApiClient: IQuoteApiClient) {
        this._quoteApiClient = quoteApiClient;
    }

    startQuote = (program: string, zipCode: string) => (dispatch) => {

        return startQuoteValidation({ zipCode }).then(
            () => {

                //var promise = Promise.resolve(zipCode);
                var promise = USPSClient.getAreaByZip(zipCode)
                    .then((result: any) => {

                        dispatch({
                            type: ACTIONS.QUOTE_STARTED,
                            zipCode: result.zip,
                            stateCode: result.state,
                            program
                        });

                        return this._quoteApiClient.createQuote(program, zipCode);
                    })
                    //.then(() => { console.log("create quote"); return quoteApiClient.createQuote(zipCode); })
                    .then((response) => {
                        dispatch({
                            type: ACTIONS.QUOTE_CREATED,
                            quote: { uid: response.data.uid, quoteId: response.data.quoteId }
                        });

                        return { quoteUid: response.data.uid, quoteId: response.data.quoteId }
                    });

                return promise;
            },
            (errors) => {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            }
        );
    };

    postStartQuote = (vehicle: IVehicle) => (dispatch) => {

        return startPostQuoteValidation({ postData: 'postData' }).then(
            () => {
                var promise = this._quoteApiClient.postCreateQuote()
                    .then((response) => {
                        dispatch({
                            type: ACTIONS.QUOTE_CREATED,
                            quote: { uid: response.data.uid, quoteId: response.data.quoteId, vehicle: vehicle },
                        });

                        return { quoteUid: response.data.uid, quoteId: response.data.quoteId, stateCode: response.data.stateCode }
                    })
                    .then((result) => {
                        this._quoteApiClient.getQuote(result.quoteUid)
                            .then((response) => {
                                dispatch({
                                    type: ACTIONS.LOAD_QUOTE,
                                    quote: response
                                });
                            });

                        return { quoteUid: result.quoteUid, quoteId: result.quoteId, stateCode: result.stateCode }
                    })
                    .then((result) => {
                        dispatch({
                            type: ACTIONS.SET_POST_QUOTE_STATE,
                            stateCode: result.stateCode
                        });

                        return { quoteUid: result.quoteUid, quoteId: result.quoteId, stateCode: result.stateCode }
                    });

                return promise;
            },
            (errors) => {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            }
        );
    };

    mapQuote = () => (dispatch) => {
        var promise = this._quoteApiClient.createQuote("", "")
            .then((response) => {
                dispatch({
                    type: ACTIONS.QUOTE_CREATED,
                    quote: { uid: response.data.uid, quoteId: response.data.quoteId }
                });

                return this._quoteApiClient.getQuote(response.data.uid)
            })
            .then((response) => {
                dispatch({
                    type: ACTIONS.LOAD_QUOTE,
                    quote: response
                });

                return { stateCode: response.data.stateCode }
            })
            .then((result) => {
                dispatch({
                    type: ACTIONS.SET_MAP_QUOTE_STATE,
                    stateCode: result.stateCode
                });
            });

        return promise;
    };

    changeZip = (zipCode: string) => (dispatch) => {

        return startQuoteValidation({ zipCode }).then(
            () => {

                var promise = USPSClient.getAreaByZip(zipCode);

                promise.then((result: any) => {

                    dispatch({
                        type: ACTIONS.CHANGE_ZIP,
                        zipCode: result.zip,
                        stateCode: result.state,
                        city: result.city
                    });
                });

                return promise;
            },
            (errors) => {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            }
        );
    };

    quoteStepChanged = (currentStep: string) => (dispatch) => {
        dispatch({
            type: ACTIONS.QUOTE_STEP_CHANGED,
            currentStep: currentStep
        });

        //eventEmitter.publish(EVENTS.QUOTE_STEP_CHANGED, currentStep);
    };

    resetAppState = () => (dispatch) => {
        dispatch({
            type: ACTIONS.RESET_APP_STATE
        });
    };

    setCarrierCustomization = (customization: ICarrierCustomization | null | undefined) => (dispatch) => {
        if (!customization) return;
        dispatch({
            type: ACTIONS.SET_CARRIER_CUSTOMIZATION,
            customization
        });
    };

    createQuote = (zipCode: string, vehicle: IVehicle | null) => (dispatch, getState) => {

        var promise = this._quoteApiClient.createQuote("", zipCode, vehicle);

        promise.then((response) => {
            if (vehicle && response.data && response.data.hasOwnProperty) {
                vehicle.id = response.data.vehicleId;
            }

            dispatch({
                type: ACTIONS.QUOTE_CREATED,
                quote: { uid: response.data.uid, vehicle: vehicle },
            });
        });

        return promise;
    };

    loadQuote = (quote: any) => (dispatch) => {

        dispatch({
            type: ACTIONS.LOAD_QUOTE,
            quote: quote
        });

        return Promise.resolve();
    };

    //export const updateVehicles = (vehicle : IVehicle) => (dispatch, getState) => {
    //    console.log("updateVehicles");

    //    dispatch({
    //        type: ACTIONS.UPDATE_VEHICLES,
    //        vehicle: vehicle,
    //    });

    //    var promise = vehiclesApiClient.updateVehicles(vehicle);

    //    return promise;
    //};

    updateVehicle = (quoteUid: string, vehicle: IVehicle, quoteStep: string) => (dispatch, getState) => {

        let validator: ((data: any) => any) | null;

        switch (quoteStep) {
            case QUOTE_STEPS.VEHICLE_DETAILS:
                validator = vehicleDetailsValidation;
                break;
            case QUOTE_STEPS.HOW_YOU_DRIVE:
                validator = howYouDriveValidation;
                break;
            default:
                validator = null;
        }

        if (null !== validator) {
            const { isValid, errors } = validator(vehicle);
            if (!isValid) {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            }
        }

        var promise = this._quoteApiClient.updateVehicle(quoteUid, vehicle, quoteStep);

        promise.then((response) => {
            vehicle.id = response.data.vehicleId;

            dispatch({
                type: ACTIONS.UPDATE_VEHICLE,
                vehicle: vehicle,
            });
        });

        return promise;
    };

    updateDriver = (quoteUid: string, driver: IDriver, quoteStep: string, stateCode: string | null = null) => (dispatch, getState) => {
        let validator: ((data: any, stateCode: string | null) => any) | null;

        switch (quoteStep) {
            case QUOTE_STEPS.ABOUT_YOU:
                validator = aboutYouValidation;
                break;
            case QUOTE_STEPS.EDUCATION_EMPLOYMENT:
                validator = educationEmploymentValidation;
                break;
            case QUOTE_STEPS.YOUR_HOME:
                validator = yourHomeValidation;
                break;
            case QUOTE_STEPS.YOUR_LICENSE:
                validator = yourLicenseValidation;
                break;
            case QUOTE_STEPS.DRIVING_HISTORY:
                validator = drivingHistoryValidation;
                break;
            default:
                validator = null;
        }

        console.log("validation.isInsured = " + driver.isInsured);
        if (null !== validator) {
            const { isValid, errors } = validator(driver, stateCode);
            if (!isValid) {

                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            }
        }

        var promise = this._quoteApiClient.updateDriver(quoteUid, driver, quoteStep, stateCode);

        promise.then((response) => {
            driver.id = response.data.driverId;

            dispatch({
                type: ACTIONS.UPDATE_DRIVER,
                driver: driver,
            });
        });

        return promise;
    };

    updateInsurance = (quoteUid: string, currentInsurance: ICurrentInsurance, quoteStep: string, stateCode: string | null = null) => (dispatch, getState) => {

        let validator: ((data: any, stateCode: string | null) => any) | null;

        switch (quoteStep) {
            case QUOTE_STEPS.CURRENT_INSURANCE:
                validator = currentInsuranceValidation;
                break;
            case QUOTE_STEPS.INSURANCE_HISTORY:
                validator = insuranceHistoryValidation;
                break;
            case QUOTE_STEPS.NEW_POLICY:
                console.log("yourNewPolicyValidation");
                validator = yourNewPolicyValidation;
                break;
            default:
                validator = null;
        }

        console.log(currentInsurance);
        if (null !== validator) {
            const { isValid, errors } = validator(currentInsurance, stateCode);
            if (!isValid) {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            }
        }

        var promise = this._quoteApiClient.updateInsurance(quoteUid, currentInsurance, quoteStep);

        promise.then((response) => {
            currentInsurance.id = response.data.insuranceId;

            dispatch({
                type: ACTIONS.UPDATE_INSURANCE,
                currentInsurance: currentInsurance,
            });
        });

        return promise;
    };

    updateContactInfo = (quoteUid: string, contactInfo: IContactInfo, quoteStep: string) => (dispatch, getState) => {

        const { isValid, errors } = contactInfoValidation(contactInfo);

        if (!isValid) {
            validationUtils.publishValidationFailure(errors);
            return Promise.reject();
        }

        var promise = this._quoteApiClient.updateContactInfo(quoteUid, contactInfo, quoteStep);

        promise.then((response) => {
            contactInfo.id = response.data.contactInfoId;

            dispatch({
                type: ACTIONS.UPDATE_CONTACT_INFO,
                contactInfo: contactInfo,
            });
        });

        return promise;
    };

    selectCoverageConfig = (coverageConfig: ICoverageConfig) => (dispatch) => {
        dispatch({
            type: ACTIONS.SELECT_COVERAGE_CONFIG,
            coverageConfig: coverageConfig,
        });

        return Promise.resolve();
    };

    selectPaymentChoice = (quoteUid: string, rate: IRealTimeAutoResult | null, paymentChoice: IPaymentChoice | null, agenciesContactInfo: IAgenciesContactInfo | null, rateError: string | null) => (dispatch, getState) => {
        if (null != paymentChoice
            && null != agenciesContactInfo
            && null != agenciesContactInfo.agencyContacts
            && agenciesContactInfo.agencyContacts.length > 0
            && null != agenciesContactInfo.agencyContacts[0].producerCode
            && null != agenciesContactInfo.agencyContacts[0].storeNumber) {

            const promise = this._quoteApiClient.updateQuoteAgency(quoteUid, agenciesContactInfo.agencyContacts[0].producerCode,
                agenciesContactInfo.agencyContacts[0].storeNumber);

            promise.then(() => {
                dispatch({
                    type: ACTIONS.PAYMENT_CHOICE_SELECTED,
                    rate: rate,
                    paymentChoice: paymentChoice,
                    agenciesContactInfo: agenciesContactInfo,
                    rateError: rateError
                });
            });

            return promise;
        }
        else {
            dispatch({
                type: ACTIONS.PAYMENT_CHOICE_SELECTED,
                rate: rate,
                paymentChoice: paymentChoice,
                agenciesContactInfo: agenciesContactInfo,
                rateError: rateError
            });
        }

        return Promise.resolve();
    };

    selectRtrPaymentChoice = (rate: IRealTimeAutoResult, paymentChoice: IPaymentChoice) => (dispatch, getState) => {
        dispatch({
            type: ACTIONS.RTR_PAYMENT_CHOICE_SELECTED,
            rate: rate,
            paymentChoice: paymentChoice,
        });

        return Promise.resolve();
    };

    agentLandingQuote = (quoteUid: string) => (dispatch) => {

        let _quoteUid;
        let _quoteId;

        return this._quoteApiClient.getQuote(quoteUid)
            .then((quoteData) => {
                dispatch({
                    type: ACTIONS.LOAD_QUOTE,
                    quote: quoteData
                });

                _quoteUid = quoteData.data.uid;
                _quoteId = quoteData.data.id;

                return this._quoteApiClient.getContactInfo(quoteUid);
            }, (errors) => {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            })
            .then((cinfoData) => {
                dispatch({
                    type: ACTIONS.LOAD_CONTACT_INFO,
                    contactInfo: cinfoData.data
                });
                console.log(_quoteUid);
                console.log(_quoteId);
                return { quoteUid: _quoteUid, quoteId: _quoteId }
            }, (errors) => {
                validationUtils.publishValidationFailure(errors);
                return Promise.reject();
            });
    };

    updateViolatioList = (violationList: IViolationList) => (dispatch) => {
        dispatch({
            type: ACTIONS.UPDATE_VIOLATION_LIST,
            violationList: violationList,
        });

        return Promise.resolve();
    };
}